import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive:
          "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline:
          "outline outline-input bg-transparent hover:bg-primary hover:text-primary-foreground hover:outline-none",
        outlineSelect:
          "outline outline-input outline-[1px] font-normal bg-transparent hover:bg-accent hover:text-accent-foreground hover:outline-none",
        outlineSelectError:
          "outline outline-destructive outline-[1px] font-normal bg-transparent hover:bg-accent hover:text-accent-foreground ",
        outlineDestructive:
          "outline outline-input bg-transparent hover:bg-destructive hover:text-destructive-foreground hover:outline-none",
        outlineSecondary:
          "outline outline-input bg-transparent hover:bg-secondary hover:text-secondary-foreground hover:outline-none",
        secondary:
          "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-10 px-4 py-2",
        xs: "h-8 rounded-lg px-2.5",
        sm: "h-9 rounded-lg px-3",
        lg: "h-11 rounded-lg px-8",
        icon: "h-10 w-10",
        iconSm: "h-8 w-8",
        iconXs: "p-0.5",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

const Button = React.forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    );
  },
);
Button.displayName = "Button";

export { Button, buttonVariants };
